import { ERROR_TAG_STYLE } from '../form.module.styles';

export const STYLES = {
  ERROR_TAG_STYLE,
};
